//Importación de librerias
import { FullCalendar } from 'vue-full-calendar'
import 'fullcalendar/dist/fullcalendar.css'
import 'fullcalendar/dist/locale/es'
import "fullcalendar/dist/fullcalendar.min.css";

//Exportamos los datos de común
export default FullCalendar;



//////////////////
// WEBPACK FOOTER
// ./static/js/fullcalendar.js
// module id = null
// module chunks = 